import React, { useCallback } from "react";
import { Link, Navigate } from "react-router-dom";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import LogoImg from "../../assets/icons/timetrap-logo.svg";
import { BrandContainer, Container, BrandIcon, Card } from "./styled";
import { SignUpForm } from "../../components/SignUpForm";
import { Text } from "@chakra-ui/layout";
import { useToast } from "@chakra-ui/react";

export const SignUp: React.FC = observer(() => {
  const { session } = useStores();
  const { t } = useTranslation();
  const toast = useToast();

  const handleSubmit = useCallback(
    async (nominative: string, email: string, password: string) => {
      try {
        await session.basicSignUp(nominative, email, password);
      } catch (err) {
        console.log(err);
        toast({
          title: t("screens.login.signUpError"),
          status: "error",
          position: "bottom-left",
        });
      }
    },
    [session, toast, t]
  );

  if (session.isLogged) {
    return <Navigate to={"/"} />;
  }

  return (
    <Container>
      <BrandContainer>
        <BrandIcon>
          <img src={LogoImg} alt={"TimeTrap"} />
        </BrandIcon>
      </BrandContainer>
      <Card>
        <Text fontSize={"3xl"} fontWeight={600}>
          {t<string>("screens.login.signUp")}
        </Text>

        <SignUpForm onSubmit={handleSubmit} />
        <Text style={{ marginTop: "2rem" }}>
          {t<string>("screens.login.alreadySignup")}{" "}
          <Link color="teal.500" to={"/login"}>
            {t<string>("screens.login.login")}
          </Link>
        </Text>
      </Card>
    </Container>
  );
});
